import { Route } from '@angular/router';
import { authGuard, publicOnlyGuard } from '@shared-data-access';

export const appRoutes: Route[] = [
  // Ruta por defecto - Redireccionar a login
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full'
  },
  
  // Ruta de autenticación - Login (SIN layout)
  {
    path: 'login',
    canActivate: [publicOnlyGuard],
    loadComponent: () => 
      import('./features/auth/login/login.component').then(m => m.LoginComponent)
  },
  
  // Rutas con layout (dashboard, módulos, etc.)
  {
    path: 'app',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./layout-wrapper.component').then(m => m.LayoutWrapperComponent),
    children: [
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full'
      },
      {
        path: 'dashboard',
        loadComponent: () =>
          import('./features/dashboard/dashboard.component').then(m => m.DashboardComponent)
      },
      {
        path: 'clientes',
        loadComponent: () =>
          import('./features/clients/clients.component').then(m => m.ClientsComponent)
      },
      {
        path: 'clientes-precargados',
        loadComponent: () =>
          import('./features/preloaded-clients/preloaded-clients.component').then(
            m => m.PreloadedClientsComponent
          )
      },
      {
        path: 'validacion-clientes',
        loadComponent: () =>
          import('./features/client-validation/client-validation.component').then(
            m => m.ClientValidationComponent
          )
      },
      {
        path: 'clientes-externos',
        loadComponent: () =>
          import('./features/external-clients/external-clients.component').then(
            m => m.ExternalClientsComponent
          )
      },
      {
        path: 'instituciones-emisoras',
        loadComponent: () =>
          import('./features/issuing-institutions/issuing-institutions.component').then(
            m => m.IssuingInstitutionsComponent
          )
      },
      {
        path: 'listas',
        loadComponent: () =>
          import('./features/lists/lists.component').then(m => m.ListsComponent)
      },
      {
        path: 'busqueda',
        loadComponent: () =>
          import('./features/search/search.component').then(m => m.SearchComponent)
      },
      {
        path: 'tipos-clientes',
        loadComponent: () =>
          import('./features/client-types/client-types.component').then(
            m => m.ClientTypesComponent
          )
      },
      {
        path: 'umbrales',
        loadComponent: () =>
          import('./features/thresholds/thresholds.component').then(
            m => m.ThresholdsComponent
          )
      },
      {
        path: 'estados-cliente',
        loadComponent: () =>
          import('./features/client-status/client-status.component').then(
            m => m.ClientStatusComponent
          )
      },
      {
        path: 'soporte',
        redirectTo: 'soporte/tickets',
        pathMatch: 'full'
      },
      {
        path: 'soporte/tickets',
        loadComponent: () =>
          import('./features/support/tickets/tickets.component').then(
            m => m.SupportTicketsComponent
          )
      },
      {
        path: 'soporte/reportes',
        loadComponent: () =>
          import('./features/support/reports/reports.component').then(
            m => m.SupportReportsComponent
          )
      },
      {
        path: 'profile',
        loadComponent: () =>
          import('./features/profile/profile.component').then(m => m.ProfileComponent)
      },
      {
        path: 'change-password',
        loadComponent: () =>
          import('./features/change-password/change-password.component').then(
            m => m.ChangePasswordComponent
          )
      },
      {
        path: 'chat/:id',
        data: { kind: 'staff' },
        loadComponent: () =>
          import('@shared-data-access/services/inbox/chat-thread.component').then(
            (m) => m.ChatThreadComponent,
          ),
      },
      // Aquí se agregarán más rutas protegidas
    ]
  },
  
  // Ruta 404 - Redireccionar a login (temporalmente)
  {
    path: '**',
    redirectTo: 'login'
  }
];
